<script setup lang="ts">
import { computed } from "vue";

import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import OptionComponent from "~/components/options/Option.vue";
import { isDefined } from "~/shared/common";
import { EditorMode } from "~/shared/enums";
import type { Property } from "~/shared/types";
import { useDataStore } from "~/stores";

const props = defineProps<{
  value: string[];
  property?: Property;
  editorMode: EditorMode;
  class?: string;
}>();

const dataStore = useDataStore();

const isBoardMode = computed(() => props.editorMode === EditorMode.BOARD);

const options = computed(() =>
  props.value.map((optionDuid) => dataStore.getOptionByDuid(optionDuid)).filter(isDefined)
);
</script>

<template>
  <component
    :is="isBoardMode ? Tooltip : Template"
    v-for="option in options"
    :key="option.duid"
    :class="isBoardMode && `max-w-full ${props.class}`"
    :text="property?.title">
    <OptionComponent
      :option="option"
      :truncate="!isBoardMode"
      show-ancestors
      :in-chip-group="isBoardMode"
      :class="!isBoardMode && props.class">
      <slot />
    </OptionComponent>
  </component>
</template>
